import { Link } from "@mui/material";
import Layout from "../Layout";
import { Link as RouterLink } from "react-router-dom";

const AfterEmailSent = () => {
  return (
    <>
      <Layout>
        <p
          className="quency-cf-normal"
          style={{ marginTop: "50px", fontSize: "1.5rem", fontWeight: 400 }}
        >
          Reset password
        </p>
        <p
          style={{
            color: "#373F41",
            fontSize: "14px",
          }}
        >
          A link has been sent to you by email. Click the link to open a window
          where you can enter a new password.
        </p>
        <Link
          component={RouterLink}
          to="/"
          sx={{
            textDecoration: "none",
            textTransform: "none",
            textAlign: "right",
            mt: "10px",
            ml: "218px",
            color: "#BAB7B7",
            fontFamily: "Inter",
            fontWeight: "400",
            fontSize: "10px",
            lineHeight: "12.1px",
            position: "relative",
            top: "195px",
            right: "-30px",
            width: "82px",
            height: "12px",
            gap: "0px",
            whiteSpace: "nowrap",
          }}
        >
          Back to Login
        </Link>
      </Layout>
    </>
  );
};
export default AfterEmailSent;
